module.exports =
  "_BROWSER":
    "PRIVATE_MODE_ALERT_MESSAGE": "This site doesn't support the private mode browsing. Please turn off the private mode and try again."
    "BLOCK_COOKIE_ALERT_MESSAGE": "You can't browse this site without cookie. Please allow using cookie on browser's privacy setting."




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/browser/i18n/en.coffee